var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgPicture = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.504,
    height: 19.5,
    viewBox: "0 0 19.504 19.5",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#484a56;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.25 -2.25)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M19.14,21.75H4.86a2.61,2.61,0,0,1-2.61-2.61V4.86A2.61,2.61,0,0,1,4.86,2.25H19.14a2.61,2.61,0,0,1,2.61,2.61V19.14a2.61,2.61,0,0,1-2.61,2.61ZM4.86,3.75A1.11,1.11,0,0,0,3.75,4.86V19.14a1.11,1.11,0,0,0,1.11,1.11H19.14a1.11,1.11,0,0,0,1.11-1.11V4.86a1.11,1.11,0,0,0-1.11-1.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M3,18.81a.76.76,0,0,1-.57-.26.75.75,0,0,1,.09-1.06l5.12-4.32a2,2,0,0,1,2.7.11l2.43,2.43a.5.5,0,0,0,.65,0L15.78,14a2,2,0,0,1,2.44,0l3.25,2.59a.754.754,0,0,1-.94,1.18l-3.24-2.6a.5.5,0,0,0-.61,0L14.32,17a2,2,0,0,1-2.61-.18L9.28,14.34a.5.5,0,0,0-.67,0l-5.13,4.3A.72.72,0,0,1,3,18.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M15,11.75A2.75,2.75,0,1,1,17.75,9,2.75,2.75,0,0,1,15,11.75Zm0-4A1.25,1.25,0,1,0,16.25,9,1.25,1.25,0,0,0,15,7.75Z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPicture);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/picture.78f2862178119c90c2e2056721609f38.svg";